import { useNextRouter } from "@/data/Content/_NextRouter";
import { useNotifications } from "@/data/Content/Notifications";
import { useLocalization } from "@/data/Localization";
import { useSettings } from "@/data/Settings";
import { TransactionErrorResponse } from "@/data/types/Basic";
import { ErrorType } from "@/data/types/Error";
import { transactionsUserActivate } from "integration/generated/transactions";
import { ComIbmCommerceRestMemberHandlerUserActivateHandlerResendActiveUserRequestBody } from "integration/generated/transactions/data-contracts";
import { RequestParams } from "integration/generated/transactions/http-client";
import { useState } from "react";
import { isErrorType, processError } from "../utils/processError";
import { UserLogon } from "@/data/Content/Login";

const resendUserActivationCallBackFetcher =
    (pub: boolean) =>
        async (
            storeId: string,
            data: ComIbmCommerceRestMemberHandlerUserActivateHandlerResendActiveUserRequestBody,
            params: RequestParams = {}
        ) =>
            await transactionsUserActivate(pub).userActivateResendActiveUser(
                storeId,
                data,
            );

export const useResendUserActivationCallback = () => {
    const { settings } = useSettings();
    const activateEmailNLS = useLocalization('ResendActivationEmail');
    const { showSuccessMessage, notifyError } = useNotifications();
    const router = useNextRouter();
    const resendUserActivationCallBackAndRedirect = async (callbackQuery: UserLogon) => {
        try {
             const resp = await resendUserActivationCallBackFetcher(true)(
                settings?.storeId ?? '',
                { logonId: callbackQuery.logonId ?? '', logonPassword: callbackQuery.logonPassword },
                {},
            );
            showSuccessMessage(activateEmailNLS.SuccessLabel.t());
            await router.push('/');
        } catch (error) {
            const resp = error as TransactionErrorResponse;
            if ('error' in resp) {
                if (isErrorType(resp.error) && resp?.error?.errors.at(0)?.errorKey === '_ERR_PERSON_WRONG_STATE_FOR_RESEND_ACTIVATE') {
                    const msg = { type: 'common-error', messageKey: '_ERR_PERSON_WRONG_STATE_FOR_RESEND_ACTIVATE' } as ErrorType;
                    notifyError(msg);
                } else {
                    const msg = processError(resp) as ErrorType;
                    notifyError(msg);
                }
            }
        }
    }
    return {
        resendUserActivationCallBackAndRedirect,
    }
}